import { render, staticRenderFns } from "./loadingSpiner.vue?vue&type=template&id=b47993e2&scoped=true"
import script from "./loadingSpiner.vue?vue&type=script&lang=js"
export * from "./loadingSpiner.vue?vue&type=script&lang=js"
import style0 from "./loadingSpiner.vue?vue&type=style&index=0&id=b47993e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47993e2",
  null
  
)

export default component.exports